import { App } from './classes/app';
import { model } from './model';
import './styles/main.css';

new App(model).init();
